import Request from '../Request.utils'
export interface IListSyncedCustomersRequestQuery {
  hasRole?: boolean;
  page?: number;
  pageSize?: number;
  search?: string;
}
export interface IDetailSyncedCustomersRequestParams {
  id: string;
}
export interface IDetailSyncedCustomersRequestQuery {
  cached?: boolean;
  forceRefresh?: boolean;
}
export interface IUpdateCustomerConfigRequestBody {
  config: string;
  customerId: string;
  value: boolean;
}
export interface IListCompaniesRequestQuery {
  page?: number;
  pageSize?: number;
  search?: string;
}
export interface IListCompanyLocationsRequestQuery {
  companyId?: string;
  externalId?: string;
  page?: number;
  pageSize?: number;
  search?: string;
}
export interface IListUserByLocationRequestParams {
  locationId: string;
}
export interface IListUserByLocationRequestQuery {
  companyId: string;
  page?: number;
  pageSize?: number;
}
export interface IListUserByCompanyRequestParams {
  companyId: string;
}
export interface IListUserByCompanyRequestQuery {
  page?: number;
  pageSize?: number;
}
export interface ISyncLocationsFromShopifyRequestBody {
  companyId?: string;
}
export interface ICreateCompanyRequestBody {
  companyLocation?: {
    billingAddress?: {
      address1?: string;
      address2?: string;
      city?: string;
      country?: string;
      countryCode?: string;
      province?: string;
      recipient?: string;
      zip?: string;
    };
    externalId?: string;
    name?: string;
    shippingAddress?: {
      address1?: string;
      address2?: string;
      city?: string;
      country?: string;
      countryCode?: string;
      province?: string;
      recipient?: string;
      zip?: string;
    };
  };
  externalId: string;
  name: string;
}
export interface ICreateLocationRequestBody {
  billingAddress?: {
    address1?: string;
    address2?: string;
    city?: string;
    country?: string;
    countryCode?: string;
    province?: string;
    recipient?: string;
    zip?: string;
  };
  companyId: string;
  externalId?: string;
  name: string;
  shippingAddress?: {
    address1?: string;
    address2?: string;
    city?: string;
    country?: string;
    countryCode?: string;
    province?: string;
    recipient?: string;
    zip?: string;
  };
}
export interface IAssignCustomerToCompanyRequestBody {
  companyId: string;
  customerId: string;
}


class SyncCustomerAPI {
  shopifyCustomerWebhook = async () => {
    const res = await Request.call('/api/sync-customers/webhook', 'POST', undefined, undefined, undefined, );
    return res;
  }
  listSyncedCustomers = async (query: IListSyncedCustomersRequestQuery) => {
    const res = await Request.call('/api/synced-customers', 'GET', undefined, query, undefined, );
    return res;
  }
  detailSyncedCustomers = async (params: IDetailSyncedCustomersRequestParams, query: IDetailSyncedCustomersRequestQuery) => {
    const res = await Request.call('/api/synced-customers/:id', 'GET', params, query, undefined, );
    return res;
  }
  updateCustomerConfig = async (body: IUpdateCustomerConfigRequestBody) => {
    const res = await Request.call('/api/update-customer-configs', 'POST', undefined, undefined, body, );
    return res;
  }
  listCompanies = async (query: IListCompaniesRequestQuery) => {
    const res = await Request.call('/api/synced-customers/companies', 'GET', undefined, query, undefined, );
    return res;
  }
  listCompanyLocations = async (query: IListCompanyLocationsRequestQuery) => {
    const res = await Request.call('/api/synced-customers/companies/locations', 'GET', undefined, query, undefined, );
    return res;
  }
  listUserByLocation = async (params: IListUserByLocationRequestParams, query: IListUserByLocationRequestQuery) => {
    const res = await Request.call('/api/synced-customers/locations/:locationId/users', 'GET', params, query, undefined, );
    return res;
  }
  listUserByCompany = async (params: IListUserByCompanyRequestParams, query: IListUserByCompanyRequestQuery) => {
    const res = await Request.call('/api/synced-customers/companies/:companyId/users', 'GET', params, query, undefined, );
    return res;
  }
  syncLocationsFromShopify = async (body: ISyncLocationsFromShopifyRequestBody) => {
    const res = await Request.call('/api/synced-customers/sync-locations-from-shopify', 'POST', undefined, undefined, body, );
    return res;
  }
  createCompany = async (body: ICreateCompanyRequestBody) => {
    const res = await Request.call('/api/synced-customers/companies', 'POST', undefined, undefined, body, );
    return res;
  }
  createLocation = async (body: ICreateLocationRequestBody) => {
    const res = await Request.call('/api/synced-customers/locations', 'POST', undefined, undefined, body, );
    return res;
  }
  assignCustomerToCompany = async (body: IAssignCustomerToCompanyRequestBody) => {
    const res = await Request.call('/api/synced-customers/assign-customer-to-company', 'POST', undefined, undefined, body, );
    return res;
  }
}
export default new SyncCustomerAPI()